/**
 * 성취기준 교육과정 id. 백엔드 `SUPPORTED_CURRICULA`와 같은 목록이다.
 * 빈 값만 2022로 본다(2015 도입 전 저장 기록은 전부 2022). 모르는 값을 2022로 바꾸면
 * 같은 key의 다른 개정 문장이 들어가므로 그대로 보내고, 서버가 `unsupported-curriculum`으로 거른다.
 */

export const DEFAULT_CURRICULUM = '2022';
export const SPECIAL_CURRICULUM = 'special-2022';
export const SUPPORTED_CURRICULA = ['2022', '2015', SPECIAL_CURRICULUM];

const MAX_CURRICULUM_ID_LENGTH = 24;

export const normalizeCurriculumId = (value) => {
  const raw = String(value ?? '').trim();
  if (!raw) return DEFAULT_CURRICULUM;
  return raw.slice(0, MAX_CURRICULUM_ID_LENGTH);
};

export const isSupportedCurriculum = (value) => SUPPORTED_CURRICULA.includes(String(value ?? '').trim());
